import { Pipe, PipeTransform } from '@angular/core';
import { FilterService } from '../services/filter.service';

@Pipe({
  name: 'filterText',
  pure: false
})
export class FilterTextPipe implements PipeTransform {
  constructor(private filterService: FilterService) {}
  transform(items: any[], searchText: string): any[] {
    if (!items) {
      return [];
    }
    if (!searchText) {
      return items;
    }
    searchText = searchText.toLowerCase();
    return items.filter(item => {
      // let propertKeys = Object.keys(item)
      let possibleValues = this.filterService.selectedColumn.some((value:any)=> item[value]? item[value].toString().toLowerCase().includes(searchText) : '')
      return possibleValues ? item : ''
    });
  }
  
}
